import { MatterLedgerLayout } from './layouts';
import { MatterLedgerDashboardView } from './components/MatterLedgerDashboardView';

export function MatterLedgerDashboardPage() {
  return (
    <MatterLedgerLayout>
      <MatterLedgerDashboardView />
    </MatterLedgerLayout>
  );
}
